import { render, staticRenderFns } from "./BiddingSearch.vue?vue&type=template&id=a55c4f08&scoped=true&"
import script from "./BiddingSearch.vue?vue&type=script&lang=js&"
export * from "./BiddingSearch.vue?vue&type=script&lang=js&"
import style0 from "./BiddingSearch.vue?vue&type=style&index=0&id=a55c4f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55c4f08",
  null
  
)

export default component.exports